    <app-dashboard
      [pageTitle]="pageTitle"
      [pageSubtitle]="pageSubtitle"
      [pageVariant]="pageVariant"
      [kpis]="kpis"
      [dataLoading]="pageDataLoading"
      
      [activeCrossFilter]="activeCrossFilter"
      [revenueDrillLevel]="revenueDrillState.level"
      [activeTrendLevel]="activeTrendLevel"
      [chart3Breadcrumb]="chart3Breadcrumb"
      [clientListRows]="clientListRows"

      [chart1Title]="chart1Title"
      chart1Subtitle="Invoice totals · current period"
      [chart1Breadcrumb]="chart1Breadcrumb"
      (chart1BreadcrumbClick)="onChart1BreadcrumbClick($event)"
      [chart1ShowDrillUp]="chart1ShowDrillUp"
      (chart1DrillUp)="onRevenueDrillUp()"
      (chart1DrillDown)="onRevenueDrillDown()"
      (chart1NextLevel)="onRevenueNextLevel()"
      (chart1ExpandAll)="onRevenueExpandAll()"
      (chart1OpenDetails)="onRevenueOpenDetails()"
      [chart1Filtered]="chart1Filtered"
      [activeRevenueTab]="activeRevenueTab"
      [activeChart1Metric]="activeChart1MetricForPage"
      [financialOverviewData]="displayFinancialOverviewData"
      [marginComparisonData]="marginComparisonData"
      [operatingCostPercentData]="operatingCostPercentData"
      [financialOverviewDrillDetail]="financialOverviewDrillDetail"
      [placementRevenuePerMonth]="placementRevenuePerMonth"
      [gpmPermVsTempByMonth]="gpmPermVsTempByMonth"
      [overviewWaterfallData]="overviewWaterfallData"
      [progressionOfFinancialMetrics]="progressionOfFinancialMetrics"
      [comparisonFinancialOverviewData]="comparisonData?.financialOverview ?? null"
      [comparisonProgressionOfFinancialMetrics]="comparisonData?.progressionOfFinancialMetrics ?? []"
      [comparisonFinancialOverviewDrillDetail]="comparisonData?.financialOverviewDrillDetail ?? []"
      [comparisonTurnoverDrillDownSummary]="comparisonData?.turnoverDrillDownSummary ?? null"
      [comparisonTurnoverDrillDownDetail]="comparisonData?.turnoverDrillDownDetail ?? []"
      [comparisonCostOfSalesDrillDownDetail]="comparisonData?.costOfSalesDrillDownDetail ?? []"
      [comparisonAdministrativeCostDrillDownSummary]="comparisonData?.administrativeCostDrillDownSummary ?? []"
      [comparisonAdministrativeCostDrillDownDetail]="comparisonData?.administrativeCostDrillDownDetail ?? []"
      [comparisonFinancialOverviewDailyDrillDetail]="comparisonData?.financialOverviewDailyDrillDetail ?? []"
      [comparisonLoading]="comparisonLoading"
      [comparisonPeriodLabel]="comparisonPeriodLabel"
      [cashCollectedLedgerDrillDown]="cashCollectedLedgerDrillDown"
      [comparisonCashCollectedLedgerDrillDown]="comparisonData?.cashCollectedLedgerDrillDown ?? []"
      [agedDebtOver90DaysDrillDown]="agedDebtOver90DaysDrillDown"
      [agedDebtBucketSummaryView]="agedDebtBucketSummaryView"
      [agedDebtBucketDetailView]="agedDebtBucketDetailView"
      [turnoverDrillDownSummary]="turnoverDrillDownSummary"
      [turnoverDrillDownDetail]="turnoverDrillDownDetail"
      [costOfSalesDrillDownDetail]="costOfSalesDrillDownDetail"
      [administrativeCostDrillDownSummary]="administrativeCostDrillDownSummary"
      [administrativeCostDrillDownDetail]="administrativeCostDrillDownDetail"
      [financialOverviewDailyDrillDetail]="financialOverviewDailyDrillDetail"
      [overviewSelectionRange]="overviewSelectionRange"
      [ebitdaFinancialOverviewData]="financialOverviewData"
      [evertimeStartDate]="currentStartDate"
      [evertimeEndDate]="currentEndDate"
      (chart1BarClick)="onRevenueBarClick($event)"
      (ebitdaBarClick)="onEbitdaBarClick($event)"
      (chart1Scroll)="onRevenueChartScroll($event)"
      (revenueLevelClick)="onRevenueLevelClick($event)"
      (chart1MetricChange)="onChart1MetricChange($event)"
      (overviewSelectionRangeChange)="onOverviewSelectionRangeChange($event)"
      (overviewSelectionClear)="onOverviewSelectionClear()"
      (overviewMonthShowTable)="onOverviewMonthShowTable($event)"

      chart2Title="Cash Flow Trend"
      chart2Subtitle="30-day rolling · receipts vs. payments"
      [chart2Filtered]="chart2Filtered"
      [trendChartData]="trendChartData"
      [trendChartOptions]="trendChartOptions"
      [agedDebtBuckets]="agedDebtBuckets"
      [currentAgedDebtSummary]="currentAgedDebtSummary"
      [unallocatedCashRows]="unallocatedCashRows"
      [agedDebtAsAtLabel]="agedDebtAsAtLabel"
      [agedDebtAsAtDate]="currentEndDate"
      [currentAgedDebtLoading]="currentAgedDebtLoading"
      [dsoTrend]="dsoTrend"
      [dsoByMonthLoading]="dsoByMonthLoading"
      [dsoTargetDays]="dsoTargetDays"
      [creditControlClients]="creditControlClients"
      [clientChaseListDrillDownDetail]="clientChaseListDrillDownDetail"
      [revenueConcentration]="revenueConcentration"
      [top10ClientsByGrossProfit]="top10ClientsByGrossProfit"
      [clientPerformanceData]="clientPerformance"
      [chart2Breadcrumb]="chart2Breadcrumb"
      (trendLevelClick)="onTrendLevelClick($event)"
      (trendDrillUp)="onTrendDrillUp()"
      (trendDrillDown)="onTrendDrillDown()"
      (trendPointSelect)="onTrendPointSelect($event)"

      chart3Title="Revenue Breakdown"
      chart3Subtitle="By category · current period"
      [chart3Filtered]="chart3Filtered"
      [breakdownChartData]="breakdownChartData"
      [breakdownDetails]="breakdownDetails"
      [breakdownCenterValue]="breakdownCenterValue"
      [breakdownCenterLabel]="breakdownCenterLabel"
      [breakdownPopoverData]="breakdownPopoverData"
      [breakdownViewModel]="breakdownViewModel"
      [hoveredBreakdownIndex]="hoveredBreakdownIndex"
      (breakdownSegmentClick)="onBreakdownSegmentClick($event)"
      (viewInvoicesClick)="onViewInvoicesClick()"
      (clientRowClick)="onClientRowClick($event)"
      (breakdownHover)="onBreakdownHover($event)"
      (breakdownClientSelectById)="onBreakdownClientSelectById($event)"
      (breakdownDrillThrough)="onBreakdownDrillThrough($event)"
      (dashboardContextAction)="onDashboardContextAction($event)"

      [crossFilterActive]="crossFilterActive"
    />
  
